/* ================================================================
   C4 × LAKERS LANDING — Shopify Build
   Alcance: todos los querySelectors van limitados al wrapper
   `.c4-lakers-landing` para no interferir con otros elementos del
   theme que puedan compartir clases (.hero, .flavor, .btn, etc.)
   ================================================================ */
(function () {
  const root = document.querySelector('.c4-lakers-landing');
  if (!root) return;

  // ---------------------------------
  // Canasta "swish" cuando entra en viewport
  // ---------------------------------
  const hoop = root.querySelector('#hoop, .hoop');
  if (hoop) {
    const hoopObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Primer swish al entrar
          hoop.classList.add('is-scored');
          setTimeout(() => hoop.classList.remove('is-scored'), 900);

          // Luego cada 4 segundos un nuevo swish mientras esté visible
          const interval = setInterval(() => {
            if (!hoop.isConnected) { clearInterval(interval); return; }
            hoop.classList.add('is-scored');
            setTimeout(() => hoop.classList.remove('is-scored'), 900);
          }, 4000);
          hoop.dataset.swishInterval = interval;
        } else if (hoop.dataset.swishInterval) {
          clearInterval(Number(hoop.dataset.swishInterval));
          delete hoop.dataset.swishInterval;
        }
      });
    }, { threshold: 0.4 });
    hoopObserver.observe(hoop);
  }

  // ---------------------------------
  // SMOOTH SCROLL para anchors internos del landing
  // ---------------------------------
  root.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href === '#') return;
      const target = root.querySelector(href);
      if (target) {
        e.preventDefault();
        const y = target.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // ---------------------------------
  // REVEAL on scroll (fade-in)
  // ---------------------------------
  const fadeObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.15 });

  root.querySelectorAll('.formula__item, .flavor, .step__header, .ignite-metric, .zero-row')
    .forEach(el => {
      if (!el.classList.contains('zero-row')) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
      }
      fadeObserver.observe(el);
    });

  // Inject visible style (scopeado al landing)
  const visibleStyle = document.createElement('style');
  visibleStyle.textContent = `
    .c4-lakers-landing .formula__item.is-visible,
    .c4-lakers-landing .flavor.is-visible,
    .c4-lakers-landing .step__header.is-visible,
    .c4-lakers-landing .ignite-metric.is-visible {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(visibleStyle);
})();
